import React, { useState, useEffect ,useRef } from "react";
import L from "leaflet";
import LineGraph from "../../../components/Admin/Graphs/Line";
import clipboardy from 'clipboardy';

import {
  // MapContainer,
  /* Polyline, */
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  
} from "react-leaflet";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { Checkbox,Button, Col, Row,notification } from "antd";
import Routing from "../MapRoutes/MapRoutes";
import { length } from 'leaflet-geometryutil';
  
// --> https://blog.logrocket.com/react-leaflet-tutorial/ <---   Para hacer que funcione el mapa

//Trazar rutas con Leaflet: https://mappinggis.com/2016/08/calculo-de-rutas-en-un-mapa-web-de-leaflet/

import "./Map_polilineas.scss";
import "leaflet/dist/leaflet.css";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";



export default function Map_polilineas(props) { 
  function copiarTexto(locations) {
    
  // const url = 'https://www.google.com.mx/maps/rpc/shorturl?authuser=0&hl=es&gl=mx&pb=!1shttps%3A%2F%2Fwww.google.com.mx%2Fmaps%2Fdir%2F'
  // let query = '';
  // for (let i = 0; i < locations.length - 1; i++) {
  //   query += locations[i][0] + '%2C' + locations[i][1] + '%2F';
  // }
  // query += '@' + locations[locations.length - 1][0] + ',' + locations[locations.length - 1][1] + '!2m2!1svXUTZN2dBa_IkPIPsb63oAs!7e81';
  // console.log("url",url)
  //   const params = {
  //     method: "GET",
  //     credentials: "include",
  //     referrerPolicy: 'strict-origin-when-cross-origin',
  //     mode:"no-cors",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   };
  // fetch(url + query, params)
  //   .then((response) => {
  //     navigator.clipboard.writeText(response);
  //     console.log('Texto copiado al portapapeles:', response);
  //     // return response.json();
  //   })
  //   .catch((err) => {
  //     console.log('error: ',err)
  //     return err.message;
  //   });
    
    const origin = locations[0];
    const destination = locations[locations.length - 1];
    const waypoints = locations.slice(1, -1);
    
    let url = `https://www.google.com/maps/dir/?api=1&destination=${destination[0]},${destination[1]}&origin=${origin[0]},${origin[1]}&waypoints=`;
    waypoints.forEach(waypoint => {
      url += `${waypoint[0]},${waypoint[1]}|`;
    });
    url = url.slice(0, -1);
    url += '&travelmode=bicycling&dir_action=navigate';
    navigator.clipboard.writeText(url);
    // console.log('Texto copiado al portapapeles:', url);
    notification["success"]({
      message: `Enlace copiado en portapapeles`
    })
    return url;
   
  };

  const mapRef = useRef();

  const [checked, setchecked] = useState([]);
  const { coordenadas } = props;
  var puntos = [];
  var puntos2 = [];
  var polilineas = [];
  var peso=[];
  var volumen=[];
  var altura=[]
  var difaltura=[]
  var rutas=[]
  var pendientes=[]

/*   peso = [
    {
      year: '1991',
      value: 3,
    },
    {
      year: '1992',
      value: 4,
    },
  ]; */

  var orden = "";
//  console.log('estas son las coordenadas',coordenadas);
  var color='white';
  var colorP='red';
  var dif=0;
  var difpen=0;
  var auxiliares=[];
  var vehicleType=[];
  var auxiliare=[];
  /* const [map, setMap] = useState(null);
  useEffect(() => {
    if (!map) return;
    const controlContainer = routingRef.current.onAdd(map);
    pluginRef.current.appendChild(controlContainer);
  }, [map]); */
  var j=0;
  for (let i = 0; i < coordenadas.length; i++) {
    if(coordenadas[i].position=='begin'){
      auxiliare=[]
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      vehicleType.push([coordenadas[i].tour_info.transptype_type])
    }else if(coordenadas[i].position=='end'){
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
      // auxiliares=[[...auxiliares,[coordenadas[i].punto1[0],coordenadas[i].punto1[1]]]]
      auxiliares=[...auxiliares,auxiliare]
      // j=j+1;
      
    }else{
      // auxiliares=[[...auxiliares,[coordenadas[i].punto1[0],coordenadas[i].punto1[1]]]]
        auxiliare.push([coordenadas[i].punto1[0],coordenadas[i].punto1[1]])
    }
  }
  console.log('auxiliares',auxiliares)

  for (let i = 0; i < coordenadas.length; i++) {
    if (filtrarTour(coordenadas[i].tour_info.order_tour, checked)) 
    { 
      puntos.push(coordenadas[i].punto1);
      
      //if(coordenadas[i].order_mode==='shipment')puntos.push(coordenadas[i].punto2)
      peso.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:coordenadas[i].sumWeight});
      volumen.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:coordenadas[i].sumItems});
      altura.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:parseInt(coordenadas[i].punto1[2])});
      

      if ((i)!==coordenadas.length-1)
        {if(coordenadas[i+1].tour_info.order_pos!==0 ){
          var fromLatLng = L.latLng(coordenadas[i].punto1[0],coordenadas[i].punto1[1]);
          var toLatLng = L.latLng(coordenadas[i+1].punto1[0],coordenadas[i+1].punto1[1]);

          var dis = fromLatLng.distanceTo(toLatLng);
          

          dif=parseInt(coordenadas[i+1].punto1[2])-parseInt(coordenadas[i].punto1[2]);
          (dif===0 || dis ===0)?difpen=0:difpen= 100*dif/dis;
          //console.log(dis , 'dis',dif)
          pendientes.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:difpen})

          ////console.log(coordenadas[i+1].punto[2],'-',coordenadas[i].punto[2],'=',dif)
          difaltura.push({category: coordenadas[i].tour_info.order_tour,position: coordenadas[i].tour_info.order_pos,weight:dif})
        }
      }
      
     
      if(coordenadas[i].tour_info.order_pos!==0 && coordenadas[i].hub==null){
        
        /* polilineas.push(
          <Polyline positions={puntos} color={colorP} />
        ) */
        

        rutas.push(<Routing /* ref={routingRef} */ color={colorP} waypoints={puntos}/>)
       console.log('rutas: ',rutas)
        puntos=[];
        (colorP==='red')?colorP='green':(colorP==='green')?colorP='brown':colorP='red';
      }
      orden = orden + coordenadas[i].nombre + "-> ";
      if(coordenadas[i].order_mode==='delivery'){
        color='green';
      }else if(coordenadas[i].order_mode==='pickup'){
        color='red';
      }else if(coordenadas[i].order_mode==='shipment'){
        color='orange';
      }else{
        color='white';
      }

      
      if(i===coordenadas.length-1){
        puntos2.push(
          <Marker 
          icon={L.divIcon({
           html: `<div class="hub-hidden">
           </div>`,
         })}
           position={coordenadas[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
               ORDER ID: {coordenadas[i].nombre} <span>({coordenadas[i].order_mode} {coordenadas[i].earlyTime1}-{coordenadas[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {coordenadas[i].numberItems} </h4>
              <h4>Peso de los items: {coordenadas[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
      }else{
        puntos2.push(
          <Marker 
            icon={L.divIcon({
              html: (coordenadas[i].tour_info.order_pos===0 )
              ?`<div class="blue-square" ></div>`
              :`<div class="hub-hidden"></div>`,
            })}
            position={coordenadas[i].punto1}>
                <Popup  
                className="popUpHub"
                closeButton={false}
                >
                <div className="popUpHub-top">
                    {coordenadas[i].nombre} 
                  </div>
                <div className="popUpHub-in">
                  <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
                  <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
                  <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
                  <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
                  <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
                  <h4>Items en vehículo: {coordenadas[i].sumItems} </h4>
                  <h4>Peso de los items: {coordenadas[i].sumWeight} </h4>
                </div>
                
                </Popup> 
   
           </Marker> 
         );
        puntos2.push(
          <Marker 
          icon={L.divIcon({
           
           html: (coordenadas[i].tour_info.order_pos===0  || coordenadas[i+1].tour_info.order_pos===0 )?`<div class="hub-hidden">
           </div>`
           :`<div class="marker-capillar">
              <div class="${color}-circle" >
              </div>
              <div class="number" >
                  ${coordenadas[i].tour_info.order_pos}
              </div>
              
              
            </div>`,
         })}
           position={coordenadas[i].punto1}>
             <Popup className="popUpMarcador" closeButton={false}>
             <div className="popUpMarcador-top">
                ORDER ID: {coordenadas[i].nombre} <span>({coordenadas[i].order_mode} {coordenadas[i].earlyTime1}-{coordenadas[i].lateTime1})</span>
              </div>
              <div className="popUpMarcador-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items a recoger/repartir: {coordenadas[i].numberItems} </h4>
              <h4>Peso de los items: {coordenadas[i].peso} </h4>
            </div>
              </Popup>
           </Marker> 
         );
         
      }
      
    }
  }

 /*  <div class="progressbarbar" 
    style={{width:"20px";
    height: "15.5px";
    background: "grey";
      }}>

    </div>
    <div class="progressbar" >
      Volumen al ${(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)}%
    </div> */
 
  function myFunction() {
    var popup = document.getElementById("myPopup");
    popup.classList.toggle("show");
  }

/*   for (let i = 0; i < hubs.length; i++) {
    
    if (checked.length>0) 
    { 
      hubs1.push(hubs[i].punto);
      hubs2.push(
       <Marker 
       icon={L.divIcon({
        html: `
        <div class="blue-square" >
          </div>`,
      })}
        position={hubs[i].punto}>
           <Popup  
            className="popUpHub"
            closeButton={false}
           >
            <div className="popUpHub-top">
                {hubs[i].nombre} 
              </div>
            <div className="popUpHub-in">
              <h4>Vehículo: {coordenadas[i].tour_info.transptype} </h4>
              <h4>Capacidad peso: {coordenadas[i].tour_info.transptype_capacity_weight} </h4>
              <h4>Capacidad items: {coordenadas[i].tour_info.transptype_capacity_items} </h4>
              <h4>% de ocupación <span>(peso)</span>: {(100*coordenadas[i].sumWeight/coordenadas[i].tour_info.transptype_capacity_weight).toFixed(2)} %</h4>
              <h4>% de ocupación <span>(items)</span>: {(100*coordenadas[i].sumItems/coordenadas[i].tour_info.transptype_capacity_items).toFixed(2)} %</h4>
              <h4>Items en vehículo: {coordenadas[i].sumItems} </h4>
              <h4>Peso de los items: {coordenadas[i].sumWeight} </h4>
            </div>
            
           </Popup> 

        </Marker> 
      );
    }
  } */
  const onChange = (checkedValues) => {
    setchecked(checkedValues);
  };

  function filtrarTour(value, checkboxs) {
    var tour_elegido = false;
    for (let i = 0; i < checkboxs.length; i++) {
      if (value === checkboxs[i]) {
        tour_elegido = true;
        break;
      }
    }
    return tour_elegido;
  }
  var num_tours_v = [];
  var rutas_descargar = [];
  var aux= parseInt(coordenadas[coordenadas.length-1].tour_info.order_tour)+1; 
  
  for (let i = 0; i < aux; i++) {
    num_tours_v.push(<Checkbox value={i.toString()}>{i}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Checkbox>);
    rutas_descargar.push(<Button className="boton"
    disabled={/* disable */false}
    style={{borderColor: "rgb(203,234,247)", 
    backgroundColor: "rgb(203,234,247)" ,
    color:'rgb(0,104,178)',
    fontFamily:'report',
    fontSize:'17px',
    marginRight:'10px'}}
    type="primary"
    onClick =  {() =>
      copiarTexto(auxiliares[i])
      }>
    {i}&nbsp;{vehicleType[i][0]}
  </Button>);

  }

  return (
    <>

    <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.3/dist/leaflet.css"
     integrity="sha256-kLaT2GOSpHechhsozzB+flnD+zUyjE2LlfWPgU04xyI="
     crossOrigin=""/>
      <script src="https://unpkg.com/leaflet@1.9.3/dist/leaflet.js"
     integrity="sha256-WBkoXOwTeyKclOHuWtc+i2uENFpDZ9YPdf5Hf+D7ewM="
     crossOrigin=""></script>
     {
      (checked.length>0)
        ?<p>{orden}</p>
        :<div></div>
      }
      <div className="leyenda">
      <div className="rutas" style={{display:'flex',flexFlow:'column' }}>
        <Checkbox.Group style={{marginBottom:'10px', width: "100%" }} onChange={onChange}>
          {num_tours_v}
        </Checkbox.Group>
          <div className="rutas" style={{display:'flex',flexFlow:'row',marginBottom:'10px' }}>
            {rutas_descargar}
          </div>
        </div>

        <div style={{display:'flex',flexFlow:'row',alignItems:'center' }}>
            <div className="orange">
            </div>
            <div className="shipment">
            shipment
            </div>
            <div className="rojo">
            </div>
            <div className="pick-up">
            pick-up
            </div>
            <div className="verde">
            </div>
            <div className="delivery">
            delivery
            </div>
            <div className="azul">
            </div>
            <div className="hubs">
            hubs
            </div>
            </div>
        </div>
      <div className="mapaRow">
        <MapContainer
          ref={mapRef}
          className="leaflet-container"
          center={coordenadas[0].punto1}
          zoom={12}
          /* dragging={true}
          doubleClickZoom={true}
          scrollWheelZoom={true}
          attributionControl={true}
          zoomControl={true} */
          /* whenCreated={setMap} */
        >
          
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {rutas}
          {puntos2}
          {/* {hubs2} */}
          {/* {polilineas} */}
          {/* <Polyline positions={puntos} color="red" /> */}
        </MapContainer>
        {/* <div style={{ border: "10px solid black" }} ref={pluginRef} /> */}
        
      </div>
      <div id="map"></div>
      {(checked.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Elevation (meters)</p>
          <LineGraph
            data={altura}
          />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>}
      {(checked.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Slope from one point to the next (calculated as a straight line) % </p>
          <LineGraph
            data={pendientes}
          />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>}
      {(checked.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Difference in elevation on the route [meters (i+1)-i].</p>
          <LineGraph
            data={difaltura}
          />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>}
      {(checked.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Weight evolution</p>
          <LineGraph
            data={peso}
          />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>}
      {(checked.length>0)
        ?<Row  justify="center" gutter={16}>
        <Col  span={24}>
        <div>
            <p></p>
          </div>
          <p>Volume evolution</p>
          <LineGraph
            data={volumen}
          />
          <div>
            <p></p>
          </div>
        </Col>
      </Row>:<p></p>}
    </>
  );
}
